import { ConfigProvider } from 'antd';
import locale from 'antd/es/locale/ru_RU';
import React from 'react';
import styles from './antdTheme.module.scss'

const CustomConfigProvider: React.FC = ({ children }) => {
  return (
    <ConfigProvider
      locale={locale}
      componentSize="middle"
      space={{ size: 16 }}
      dropdownMatchSelectWidth={false}
      getPopupContainer={(trigger) => trigger?.parentNode as HTMLElement}
    >
      <div className={styles.container}>
        {children}
      </div>
    </ConfigProvider>
  );
};

export default CustomConfigProvider;